'use strict';

(function () {
  'use strict';

  angular.module('msTracker').filter('chartLabel', function () {
    return function (value, range) {
      switch (range) {
        case 'week':
        case 'month':
          return moment(value).format('D');
        case 'year':
          return moment(value).format('MMM');
        default:
          return moment(value).format('MMM D');
      }
    };
  }).filter('chartTitle', function () {
    return function (chartData, range) {
      if (_.isUndefined(chartData)) {
        return;
      }
      switch (range) {
        case 'week':
        case 'month':
          return moment(chartData[0].start).format('ll') + ' – ' + moment(chartData[chartData.length - 1].start).format('ll');
        case 'year':
          return moment(chartData[0].start).format('MMM YYYY') + ' – ' + moment(chartData[chartData.length - 1].start).format('MMM YYYY');
        default:
          return moment(chartData[0].start).format('MMM D');
      }
    };
  }).filter('chartBarHeight', function () {
    return function (value) {
      if (value === null) {
        return value;
      }
      if (value < 20) {
        return '2%';
      }
      if (value >= 20 && value < 40) {
        return '25%';
      }
      if (value >= 40 && value < 60) {
        return '50%';
      }
      if (value >= 60 && value < 80) {
        return '75%';
      }
      if (value >= 80) {
        return '100%';
      }
    };
  });
})();